import "./style.scss";

const Button = ({ children, isSubmit, classNames = "", ...btnProps }) => {
  return (
    <button
      className={`custom-button ${
        isSubmit ? "submit-button" : ""
      } ${classNames}`}
      {...btnProps}
    >
      {children}
    </button>
  );
};

export default Button;
